var _g, _defs;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCross = function SvgCross(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_690_6916)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.664 11.7708C10.9696 12.0764 11.4652 12.0764 11.7708 11.7708C12.0764 11.4652 12.0764 10.9696 11.7708 10.664L10.664 11.7708ZM1.336 0.229221C1.03037 -0.0764071 0.534851 -0.0764071 0.229221 0.229221C-0.0764071 0.534851 -0.0764071 1.03037 0.229221 1.336L1.336 0.229221ZM11.7708 1.336C12.0764 1.03037 12.0764 0.534851 11.7708 0.229221C11.4652 -0.0764071 10.9696 -0.0764071 10.664 0.229221L11.7708 1.336ZM0.229221 10.664C-0.0764071 10.9696 -0.0764071 11.4652 0.229221 11.7708C0.534851 12.0764 1.03037 12.0764 1.336 11.7708L0.229221 10.664ZM0.229221 1.336L10.664 11.7708L11.7708 10.664L1.336 0.229221L0.229221 1.336ZM10.664 0.229221L0.229221 10.664L1.336 11.7708L11.7708 1.336L10.664 0.229221Z",
    fill: "#002445"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_690_6916"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCross, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cross.d6924831.svg";
export { ForwardRef as ReactComponent };